import { Component, h, Prop, Host, State, Watch } from "@stencil/core";
import { TrackResponse } from "./track-response";
import api from "../../utils/api";

@Component({
    tag: "ux-w-track",
    styleUrl: "track.scss",
    shadow: false
})
export class Track {
    /** URL where this widget can request the data */
    @Prop() url: string = "";
    /** This holds the response from the API with all Information required to show the widget */
    @State() data: TrackResponse = null;
    /** data is loading */
    @State() loading: boolean = false;

    @Watch("url")
    componentWillLoad() {
        if (this.url === "") {
            // eslint-disable-next-line no-console
            console.warn("url needs to be supplied for WidgetTrack");
            return;
        }
        window.setTimeout(() => {
            if (this.data === null) {
                this.loading = true;
            }
        });
        api<TrackResponse>(this.url)
            .then((data: TrackResponse) => {
                this.data = data;
                this.loading = false;
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error));
    }

    render() {
        const baseClass = "ux-w-track";
        if (this.loading) {
            return (
                <Host class={baseClass}>
                    <ux-w-wrapper isLoading />
                </Host>
            );
        }
        if (this.data === null) {
            return null;
        }

        const {
            link,
            linkTitle,
            title,
            orders,
            additionalTile,
            noOrdersText,
            noData,
            noDataText
        } = this.data;
        const hasOrders = orders?.length > 0;

        const linkItem =
            hasOrders && typeof additionalTile === "object" ? (
                <div class={`${baseClass}__order-item`}>
                    <ux-w-link-item
                        icon="order-status-package-checkmark"
                        headline={additionalTile.title}
                        link={additionalTile.link}
                        linkLabel={additionalTile.linkText}
                    />
                </div>
            ) : null;

        return (
            <Host class={baseClass}>
                <ux-w-wrapper url={link} linkTitle={linkTitle} headline={title}>
                    <div slot="content">
                        {!hasOrders && !noData && (
                            <ux-w-empty icon="order-status-package-checkmark">
                                <div innerHTML={noOrdersText}></div>
                            </ux-w-empty>
                        )}
                        {!hasOrders && noData && (
                            <ux-w-empty icon="crane">
                                <div innerHTML={noDataText}></div>
                            </ux-w-empty>
                        )}
                        {orders?.map((order) => (
                            <div class={`${baseClass}__order-item`}>
                                {order.shipments.map((shipment) => (
                                    <ux-w-track-delivery-item
                                        headline={shipment.title}
                                        statusType={shipment.status.type}
                                        statusText={shipment.status.text}
                                        label={shipment.label}
                                        date={shipment.date}
                                        orderLink={order.orderLink}
                                        orderLinkTitle={order.orderLinkTitle}
                                        orderNumber={order.orderNumber}
                                        trackingNumber={
                                            shipment.tracking?.number
                                        }
                                        trackingLink={shipment.tracking?.link}
                                        trackingLinkTitle={
                                            shipment.tracking?.linkTitle
                                        }
                                    ></ux-w-track-delivery-item>
                                ))}
                            </div>
                        ))}
                        {linkItem}
                    </div>
                </ux-w-wrapper>
            </Host>
        );
    }
}
